<template>
  <GlobalNav>
    <div class="h-100 d-flex flex-column justify-content-center">
      <LoadingState :size="50" />
    </div>
  </GlobalNav>
</template>

<script>
import constants from "@/utils/constants";
import GlobalNav from "@/components/nav/GlobalNav";
import LoadingState from "@/components/display/LoadingState";
import { onMounted } from "vue";
import router from "@/router";
import store from "@/store";

export default {
  name: "LoginAsPage",
  components: {
    GlobalNav,
    LoadingState,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    onMounted(() => {
      store.dispatch("analytics/send", { name: "loginAsAdmin" });
      store
        .dispatch("auth/loginAs", props.token)
        .then(() => router.push({ name: constants.ROUTES.HOME }));
    });
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
